import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { styled } from 'styled-components';
/**
 * Recursive function to get the column span for a given screen size.
 * @param size Screen size
 * @param columnSpan
 * @returns
 */
const getSpanSizeForColumnSpan = (size, columnSpan) => {
    if (!columnSpan) {
        return 'auto';
    }
    let span = columnSpan.s;
    switch (size) {
        case 'S':
            span = columnSpan.s;
            break;
        case 'M':
            return columnSpan.m ?? getSpanSizeForColumnSpan('S', columnSpan);
        case 'L':
            return columnSpan.l ?? getSpanSizeForColumnSpan('M', columnSpan);
        case 'XL':
            return columnSpan.xl ?? getSpanSizeForColumnSpan('L', columnSpan);
        case 'XXL':
            return columnSpan.xxl ?? getSpanSizeForColumnSpan('XL', columnSpan);
        default:
            span = columnSpan.s;
            break;
    }
    return span;
};
/**
 * Recursive function to get the column span for a given screen size.
 * @param size Screen size
 * @param columns
 * @returns
 */
const getSpanForColumns = (size, columns) => {
    let span = 'auto';
    switch (size) {
        case 'S':
            span = `${columns.s[0]} / ${columns.s[1]}`;
            break;
        case 'M':
            span = columns.m ? `${columns.m[0]} / ${columns.m[1]}` : getSpanForColumns('S', columns);
            break;
        case 'L':
            span = columns.l ? `${columns.l[0]} / ${columns.l[1]}` : getSpanForColumns('M', columns);
            break;
        case 'XL':
            span = columns.xl ? `${columns.xl[0]} / ${columns.xl[1]}` : getSpanForColumns('L', columns);
            break;
        case 'XXL':
            span = columns.xxl
                ? `${columns.xxl[0]} / ${columns.xxl[1]}`
                : getSpanForColumns('XL', columns);
            break;
        default:
            span = `${columns.s[0]} / ${columns.s[1]}`;
            break;
    }
    return span;
};
export const GridItem = forwardRef(({ children, columnSpan, columns, onMouseEnter, onMouseLeave, className }, ref) => {
    return (_jsx(StyledGridItem, { ref: ref, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, "$columnSpan": columnSpan, "$columns": columns, className: className, children: children }));
});
const StyledGridItem = styled.div `
  grid-column: ${props => {
    if (props.$columns) {
        return getSpanForColumns('S', props.$columns);
    }
    return `span ${getSpanSizeForColumnSpan('S', props.$columnSpan)}`;
}};

  @media (min-width: 600px) {
    grid-column: ${props => {
    if (props.$columns) {
        return getSpanForColumns('M', props.$columns);
    }
    return `span ${getSpanSizeForColumnSpan('M', props.$columnSpan)}`;
}};
  }

  @media (min-width: 900px) {
    grid-column: ${props => {
    if (props.$columns) {
        return getSpanForColumns('L', props.$columns);
    }
    return `span ${getSpanSizeForColumnSpan('L', props.$columnSpan)}`;
}};
  }

  @media (min-width: 1200px) {
    grid-column: ${props => {
    if (props.$columns) {
        return getSpanForColumns('XL', props.$columns);
    }
    return `span ${getSpanSizeForColumnSpan('XL', props.$columnSpan)}`;
}};
  }

  @media (min-width: 1600px) {
    grid-column: ${props => {
    if (props.$columns) {
        return getSpanForColumns('XXL', props.$columns);
    }
    return `span ${getSpanSizeForColumnSpan('XXL', props.$columnSpan)}`;
}};
  }
`;
//# sourceMappingURL=GridItem.js.map